import { Component, OnDestroy, computed, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription, filter } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { PermisosService } from '../../services/permisos.service';
import { MigasComponent } from '../migas/migas.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, MigasComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnDestroy {
  /** Menú de navegación desplegado (solo en pantallas estrechas). */
  readonly menuAbierto = signal(false);

  /** Tipo de cuenta de la sesión según los permisos efectivos (dato real del contexto; no hay nombre de usuario disponible). */
  readonly cuenta = computed(() => {
    switch (this.permisos.contexto()?.tipo) {
      case 'persona': return 'Cuenta de persona';
      case 'asociacion': return 'Cuenta de asociación';
      default: return 'Sesión iniciada';
    }
  });

  private readonly suscripcion: Subscription;

  constructor(
    protected router: Router,
    private authService: AuthService,
    protected permisos: PermisosService
  ) {
    // Al navegar se cierra el menú desplegable
    this.suscripcion = this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.menuAbierto.set(false));
  }

  ngOnDestroy(): void {
    this.suscripcion.unsubscribe();
  }

  /** Con <base href="/"> el ancla #contenido apuntaría a la raíz: se enfoca el contenido directamente. */
  saltarAlContenido(evento: Event): void {
    evento.preventDefault();
    document.getElementById('contenido')?.focus();
  }

  alternarMenu(): void {
    this.menuAbierto.update(abierto => !abierto);
  }

  get verAsociaciones(): boolean {
    return this.permisos.tieneAlguno(['asociados:consultar', 'asociaciones:consultar', 'asociaciones:escribir', 'historico:consultar']);
  }

  get hayAdministracion(): boolean {
    return this.permisos.tieneGlobal('asociaciones:estado') || this.permisos.tieneGlobal('permisos:gestionar') || this.permisos.tieneGlobal('acceso:bloqueos:consultar');
  }

  logout() {
    this.permisos.limpiar();
    this.authService.logout();
    this.router.navigateByUrl('login');
  }

}
